import { UseComboboxStateChange } from "downshift";
import { useGenericQuery } from "../../hooks/useQueries";
import DefaultDropdownItem from "../dropdown/DefaultDropdownItem";
import SuperDropdown from "../dropdown/SuperDropdown";
import DefaultLoadingError from "../error/DefaultLoadingError";
import Spinner from "../spinner/Spinner";

export default function AutoCompleteInteresse(props: {
  onSelectedItemChange: (event: UseComboboxStateChange<IInteresse>) => void;
  clearAfterSelection?: boolean;
  placeholder?: string;
}) {
  const { onSelectedItemChange, clearAfterSelection, placeholder } = props;

  const { data, isPending, error } = useGenericQuery<IInteresse>("interesser", {
    orderBy: "navn",
  });

  if (isPending) {
    return (
      <Spinner
        inline
        label="Henter data"
        className="form-control justify-content-start"
        size={14}
      />
    );
  }

  return (
    <>
      {(!data || error) && <DefaultLoadingError label={String(error)} />}
      <SuperDropdown
        clearInputAfterSelection={clearAfterSelection}
        disabled={!data || Boolean(error)}
        filterKeys={["navn"]}
        items={data}
        itemsIdKey="id"
        itemToString={(item) => item?.navn ?? ""}
        itemToElement={(item) => <DefaultDropdownItem label={item.navn} />}
        placeholder={placeholder}
        onSelectedItemEvent={(event) => onSelectedItemChange(event)}
      />
    </>
  );
}
